import { render, staticRenderFns } from "./CoinifyCallbackPage.vue?vue&type=template&id=7514e7c0&scoped=true"
import script from "./CoinifyCallbackPage.vue?vue&type=script&lang=js"
export * from "./CoinifyCallbackPage.vue?vue&type=script&lang=js"
import style0 from "./CoinifyCallbackPage.vue?vue&type=style&index=0&id=7514e7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7514e7c0",
  null
  
)

export default component.exports